import { Injectable } from '@angular/core';
import { CompanyDetails, CompaniesEnum, HomeTabsEnum, HomeSubtabsEnum, BuilderInfo, Gasbca, BCASearch, Subsidiary } from '@app/core/models';
import { BehaviorSubject } from 'rxjs';


/* istanbul ignore next */
@Injectable({
  providedIn: 'root'
})
export class SessionService {
  paramLdc: string = CompaniesEnum.SC;
  Bid: string;
  User: string;
  activeLdc: CompanyDetails;
  sourceToContract: string;
  projectName: string;

  public messageSource = new BehaviorSubject<any>(null);
  GridData = this.messageSource.asObservable();

  public flag = new BehaviorSubject<any>(null);
  waitFlag = this.flag.asObservable();

  public result = new BehaviorSubject<BuilderInfo>(null);
  builderData = this.result.asObservable();

  public bcaData = new BehaviorSubject<Gasbca>(null);
  BcaData = this.bcaData.asObservable();

  public projectList = new BehaviorSubject<any>(null);
  ProjectList$ = this.projectList.asObservable();

  public projectData = new BehaviorSubject<any>(null);
  ProjectData$ = this.projectData.asObservable();

  public showActiveProjectData = new BehaviorSubject<any>(null);
  ShowActiveProjectData$ = this.showActiveProjectData.asObservable();

  public companyNames = new BehaviorSubject<any>(null);
  builderCompanies = this.companyNames.asObservable();

  public search = new BehaviorSubject<BCASearch>(null);
  searchFilter = this.search.asObservable();

  public searchInside = new BehaviorSubject<any>(null);
  SearchInside$ = this.searchInside.asObservable();

  public showBuilderHeader = new BehaviorSubject<any>(null);
  showBuilderHeader$ = this.showBuilderHeader.asObservable();

  public subsidiaryInfo = new BehaviorSubject<Subsidiary[]>(null);
  subsidiaryDetails = this.subsidiaryInfo.asObservable();

  // TODO: DSS: created an observable to support failing applicant calls - BT 3/5/24
  public activeLdc$ = new BehaviorSubject<CompanyDetails>(null);
  activeLdcDetails = this.activeLdc$.asObservable();

  constructor() { }
  // function to store subsidiary details
  GetSubsidiary(passSubsidiaryDetails: Subsidiary[]) {
    this.subsidiaryInfo.next(passSubsidiaryDetails);
  }
  // function to store bca a project number and gr number
  GetGrid(passGrid: Object) {
    this.messageSource.next(passGrid);
  }
  // function to store wait flag
  GetwaitFlag(passFlag: boolean) {
    this.flag.next(passFlag);
  }
  // function to store builder information
  GetBuilderData(passBuilderData: BuilderInfo) {
    this.result.next(passBuilderData);
  }
  // function to store BCA grid data
  GetBcaData(passBcaData: Gasbca) {
    this.bcaData.next(passBcaData);
  }
  // function to store project data
  GetProjectData(passProjectData: any) {
    this.projectData.next(passProjectData);
  }

  // function to pass totalProjectList
  GetProjectList(passProjectList: any) {
    this.projectList.next(passProjectList);
  }
  // function to store whether to show active projects
  GetShowActiveProjects(passActiveProject: any) {
    this.showActiveProjectData.next(passActiveProject);
  }

  // function to store to show builder header
  GetShowBuilderHeader(show: boolean) {
    this.showBuilderHeader.next(show);
  }

  // function to store builder company data
  GetCompanies(passBuilderCompanies: any[]) {
    this.companyNames.next(passBuilderCompanies);
  }
  // function to store search filters at home screen
  GetSearchFilter(passSearchfilters: BCASearch) {
    this.search.next(passSearchfilters);
  }

  // function to store seachInside filters at project panel
  GetSearchInsideFilter(passSearchInside: any) {
    this.searchInside.next(passSearchInside);
  }

  // TODO: DSS: Created this to fix a race condition on applicant OnInit where code is sometimes undefined - BT 3/5/24
  GetActiveLdc(passActiveLdc) {
    this.activeLdc$.next(passActiveLdc);
  }
}

